// SubscriberRow.js

import React from "react";
import { Text, View } from "react-native";
import Anchor from "../../Partials/Anchor";

const Subscriber = ({rowIndex, customerObj}) => {
	const _theme = window.main.theme;
	const editCustomer = ()=>{
		window.main.lib.setCurrentView(`/organization/view/${customerObj.organization_id}`, customerObj);
	};
	return (
		<View style={{display:"flex",flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",flexGrow:1,flexShrink:1,alignSelf:"stretch",position:"relative",..._theme.borders.r}}>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-end",padding:5,flexBasis:40,flexGrow:0,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor}}>{(Number(rowIndex)||0)+1}.</Text>
			</View>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:300,flexGrow:1,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor}}><Anchor style={{..._theme.fauxlink}} onPress={editCustomer} href={`/subscriberedit/org/${customerObj.organization_id}`}>{customerObj.name||"[Missing Name]"}{!!customerObj.shortname && <Text> ({customerObj.shortname})</Text>}</Anchor>&nbsp;</Text>
			</View>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:250,flexGrow:0,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{customerObj.public_email}&nbsp;</Text>
			</View>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:150,flexGrow:0,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{customerObj.public_phone}&nbsp;</Text>
			</View>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:250,flexGrow:0,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{customerObj.public_website}&nbsp;</Text>
			</View>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:100,flexGrow:0,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor}}>{customerObj.locations_count}&nbsp;</Text>
			</View>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:80,flexGrow:0,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor}}>{customerObj.doctors_count}&nbsp;</Text>
			</View>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:80,flexGrow:0,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor}}>{customerObj.techs_count}&nbsp;</Text>
			</View>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:80,flexGrow:0,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor}}>{customerObj.staff_count}&nbsp;</Text>
			</View>
			<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:80,flexGrow:0,..._theme.borders.bl}}>
				<Text style={{color:_theme.colors.mode.textColor}}>{customerObj.is_disabled ? "Disabled" : "Active"}&nbsp;</Text>
			</View>
		</View>
	);
};

export default Subscriber;
